import { createRouter, createWebHistory } from 'vue-router'
import config from './config'
import routesAdmin from './routes.admin'
import routesUser from './routes.user'

const router = createRouter({
  history: createWebHistory(config.baseUrl),
  routes: config.interface === 'user' ? routesUser : routesAdmin
})

export default router
